/*
 * product-runtime.js — self-hosted runtime
 * on the product-main section. Zero third-party dependency. Reproduces:
 *   - quantity +/- buttons
 *   - selling-plan selector (one-time vs subscription plans)
 *   - add-to-cart -> AJAX /cart/add.js {id, quantity, selling_plan} then open the
 *     drawer. Uses a pristine iframe fetch so Appstle's window.fetch patch can't
 *     inject its plan. The <a href="/cart/<variant>:1"> permalink is the no-JS
 *     fallback (also used if the AJAX call fails), so buying can never fully break.
 *   - open-overlay (image/info panels) via [data-state] toggling
 *   - product carousel: Swiper replaced by a CSS scroll-snap slider + arrows
 */
(function () {
  'use strict';

  // ---- pristine fetch (bypass Appstle's window.fetch patch) ----
  var _cf = null, _cw = null;
  function cleanFetch(url, opts) {
    try {
      if (!_cf) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        (document.body || document.documentElement).appendChild(f);
        _cw = f.contentWindow;
        _cf = _cw.fetch;
      }
      var abs = String(url).charAt(0) === '/' ? window.location.origin + url : url;
      return _cf.call(_cw, abs, opts);
    } catch (e) {
      return fetch(url, opts);
    }
  }

  function openDrawer() {
    var d = document.getElementById('CartDrawer');
    if (d && typeof d.show === 'function') { d.show(); return true; }
    return false;
  }

  function productScope(el) {
    return el.closest('[data-pdp-form-variant-id]') || document;
  }

  // -------------------------------------------------------------- quantity
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[data-pdp-action-type="quantity-increment"], [data-pdp-action-type="quantity-decrement"]'
    );
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.parentElement;
    var input = (wrap && wrap.querySelector('input[name="quantity"]')) ||
      productScope(btn).querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 999;
    var v = parseInt(input.value, 10) || min;
    v += btn.getAttribute('data-pdp-action-type') === 'quantity-increment' ? 1 : -1;
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ------------------------------------------------------- selling plan
  function applyPlanSelection(sel) {
    var form = productScope(sel);
    form.querySelectorAll('.pdp-selling-plan-selector[data-pdp-selling-plan-id]')
      .forEach(function (s) { s.setAttribute('data-pdp-state', 'inactive'); });
    sel.setAttribute('data-pdp-state', 'active');
    sel.querySelectorAll('.pdp-selling-plan-selector').forEach(function (s) {
      s.setAttribute('data-pdp-state', 'active');
    });
    // (selected outline is driven by [data-pdp-state="active"] in CSS)
    // Reveal the 1/2/3-month frequency picker for a subscription and default it
    // to the subscription card's plan (1 month); hide it for one-time.
    var planId = sel.getAttribute('data-pdp-selling-plan-id');
    var isSub = planId !== 'one-time-purchase';
    var picker = form.querySelector('[data-pdp-type="SELLING_PLAN_PICKER"]');
    if (picker) {
      picker.style.setProperty('display', isSub ? 'flex' : 'none', 'important');
      var freq = picker.querySelector('select');
      if (isSub && freq) {
        if (planId) freq.value = planId;
        syncPlanLabel(freq);
      }
    }
    // Roll out the "how it works" panel (header + tiles) with the picker.
    var info = form.querySelector('[data-lv-sub-info]');
    if (info) info.classList.toggle('lv-open', isSub);
    var effectivePlan = planId;
    if (isSub && picker) { var _f = picker.querySelector('select'); if (_f && _f.value) effectivePlan = _f.value; }
    updatePlanUrl(effectivePlan);
  }
  // Reflect the chosen plan in the URL (?selling_plan=<id>), like the Appstle widget.
  // Re-applied on a short delay so it survives the theme's variant-URL rewrite.
  function updatePlanUrl(plan) {
    function apply() {
      try {
        var url = new URL(window.location.href);
        if (!plan || plan === 'one-time-purchase') { url.searchParams.delete('selling_plan'); }
        else { url.searchParams.set('selling_plan', plan); }
        window.history.replaceState({}, document.title, url.toString());
      } catch (err) {}
    }
    apply();
    setTimeout(apply, 80);
    setTimeout(apply, 300);
  }

  // Instant's custom select overlays a hidden <select> with a visible label
  // span; keep that label in sync (it otherwise stays "No option selected").
  function syncPlanLabel(select) {
    if (!select) return;
    var fs = select.closest('[data-pdp-type="SELLING_PLAN_PICKER"]');
    var label = fs && fs.querySelector('[data-pdp-type="selected-selling-plan-option"]');
    var opt = select.options[select.selectedIndex];
    if (label && opt) label.textContent = opt.text.trim();
    syncFreqTiles(select);
  }
  // Reflect the hidden <select>'s value on the visible frequency tiles. Called
  // from syncPlanLabel, so it fires on every path that changes the plan
  // (card activation, tile click, ?selling_plan= init).
  function syncFreqTiles(select) {
    if (!select) return;
    var fs = select.closest('[data-pdp-type="SELLING_PLAN_PICKER"]');
    if (!fs) return;
    fs.querySelectorAll('[data-lv-freq-tile]').forEach(function (tile) {
      var on = tile.getAttribute('data-plan-id') === select.value;
      tile.classList.toggle('is-active', on);
      tile.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name$="__selling_plan"]')) {
      syncPlanLabel(e.target);
      updatePlanUrl(e.target.value);
      var f = productScope(e.target);
      var d = variantData();
      if (d) { var v = matchVariant(d, currentSelection(f)); if (v) applySubPrice(f, v); }
    }
  });

  // Frequency tiles drive the hidden <select> (source of truth). Setting its
  // value + dispatching 'change' reuses the existing change handler (label,
  // URL and price sync). Runs before the sub-card handler below.
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('[data-lv-freq-tile]');
    if (!tile) return;
    e.preventDefault();
    var fs = tile.closest('[data-pdp-type="SELLING_PLAN_PICKER"]');
    var freq = fs && fs.querySelector('select[name$="__selling_plan"]');
    if (!freq) return;
    var planId = tile.getAttribute('data-plan-id');
    if (freq.value !== planId) {
      freq.value = planId;
      freq.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      syncFreqTiles(freq);
    }
  });

  document.addEventListener('click', function (e) {
    // Clicks inside the frequency picker (tiles / hidden select) must not
    // re-trigger the sub-card selection, which would reset the chosen frequency.
    if (e.target.closest('[data-pdp-type="SELLING_PLAN_PICKER"]')) return;
    var sel = e.target.closest('.pdp-selling-plan-selector[data-pdp-selling-plan-id]');
    if (!sel) return;
    e.preventDefault();
    applyPlanSelection(sel);
  });

  // Auto-select the plan from ?selling_plan=<id> in the URL (Appstle-compatible).
  function initPlanFromUrl() {
    var sp = null;
    try { sp = new URLSearchParams(window.location.search).get('selling_plan'); } catch (e) {}
    if (!sp || sp === 'one-time-purchase') return;
    var subCard = document.querySelector('.pdp-selling-plan-selector[data-pdp-selling-plan-id]:not([data-pdp-selling-plan-id="one-time-purchase"])');
    if (!subCard) return;
    applyPlanSelection(subCard);
    var form = productScope(subCard);
    var picker = form.querySelector('[data-pdp-type="SELLING_PLAN_PICKER"]');
    var freq = picker && picker.querySelector('select');
    if (freq && Array.prototype.some.call(freq.options, function (o) { return o.value === sp; })) {
      freq.value = sp;
      syncPlanLabel(freq);
      updatePlanUrl(sp);
    } else {
      // Unknown plan id in the URL: keep the subscription selection but
      // normalize the URL to the plan that is actually applied.
      updatePlanUrl(freq && freq.value ? freq.value : null);
    }
  }
  function initPlan() { initPlanFromUrl(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlan);
  } else { initPlan(); }

  function selectedPlan(form) {
    var active = form.querySelector(
      '.pdp-selling-plan-selector[data-pdp-state="active"][data-pdp-selling-plan-id]'
    );
    var id = active && active.getAttribute('data-pdp-selling-plan-id');
    if (!id || id === 'one-time-purchase') return null;
    // Subscription: use the delivery frequency chosen in the picker if present.
    var picker = form.querySelector('select[name$="__selling_plan"]');
    return (picker && picker.value) ? picker.value : id;
  }

  // ---------------------------------------------------------- variant switching
  // The section renders the purchase widget once from the first variant; when a
  // product has multiple variants the picker never re-rendered price / ids. This
  // reads the per-variant data emitted in <script data-pdp-variant-data> and, on
  // a variant radio change, updates the shown price/compare-at/saved %, the
  // subscription price for the active plan, the form + add-to-cart variant id,
  // availability, and the no-JS permalink fallback.
  var _variants = null;
  function variantData() {
    if (_variants) return _variants;
    var el = document.querySelector('script[data-pdp-variant-data]');
    if (!el) return null;
    try { _variants = JSON.parse(el.textContent); } catch (e) { _variants = null; }
    return _variants;
  }
  function currentSelection(form) {
    var opts = [];
    form.querySelectorAll('[data-pdp-type="VARIANT_PICKER"]').forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }
  function matchVariant(data, opts) {
    for (var i = 0; i < data.length; i++) {
      var vo = data[i].options || [];
      if (vo.length !== opts.length) continue;
      var ok = true;
      for (var j = 0; j < opts.length; j++) { if (vo[j] !== opts[j]) { ok = false; break; } }
      if (ok) return data[i];
    }
    return null;
  }
  function setPrice(scope, selector, value) {
    var el = scope.querySelector(selector);
    if (el && value != null) el.textContent = value;
  }
  function toggle(el, show) {
    if (!el) return;
    if (show) el.style.removeProperty('display');
    else el.style.setProperty('display', 'none');
  }
  function applySubPrice(form, v) {
    var sub = form.querySelector('.pdp-selling-plan-selector[data-pdp-selling-plan-id]:not([data-pdp-selling-plan-id="one-time-purchase"])');
    if (!sub) return;
    var select = form.querySelector('select[name$="__selling_plan"]');
    var plan = null;
    if (v.plans) {
      if (select && select.value && v.plans[select.value]) plan = v.plans[select.value];
      else { var keys = Object.keys(v.plans); if (keys.length) plan = v.plans[keys[0]]; }
    }
    var price = plan ? plan.price : v.price;
    var compare = plan ? plan.compare_at : v.compare_at;
    var onSale = plan ? plan.on_sale : v.on_sale;
    var saved = plan ? plan.saved : v.saved;
    setPrice(form, '[data-pdp-dynamic-content-source="PRICE"].pdp-text-6', price);
    var c = form.querySelector('[data-pdp-dynamic-content-source="COMPARE_AT"].pdp-el-4');
    if (c) { c.textContent = compare; toggle(c, onSale); }
    var s = form.querySelector('[data-pdp-dynamic-content-source="SAVED_PERCENTAGE"].pdp-el-40');
    if (s) { s.textContent = saved + ' %'; toggle(s, onSale); }
  }
  function applyVariant(form, v) {
    if (!v) return;
    form.setAttribute('data-pdp-form-variant-id', v.id);
    var atc = form.querySelector('[data-pdp-action-type="add-to-cart"]');
    if (atc) {
      atc.setAttribute('data-pdp-action-variant-id', v.id);
      if (v.available) { atc.removeAttribute('disabled'); atc.setAttribute('data-pdp-disabled', 'false'); }
      else { atc.setAttribute('disabled', 'disabled'); atc.setAttribute('data-pdp-disabled', 'true'); }
      if (atc.hasAttribute('href')) atc.setAttribute('href', '/cart/' + v.id + ':1');
    }
    // one-time price block
    setPrice(form, '[data-pdp-dynamic-content-source="PRICE"].pdp-text-22', v.price);
    var otCompare = form.querySelector('[data-pdp-dynamic-content-source="COMPARE_AT"].pdp-el-44');
    if (otCompare) { otCompare.textContent = v.compare_at; toggle(otCompare, v.on_sale); }
    var otSaved = form.querySelector('[data-pdp-dynamic-content-source="SAVED_PERCENTAGE"].pdp-el-2');
    if (otSaved) {
      otSaved.textContent = v.saved + ' %';
      toggle(otSaved.closest('.pdp-container-29'), v.on_sale);
    }
    applySubPrice(form, v);
    showVariantMedia(v);
  }
  // Show the selected variant's image. When the gallery is tagged per variant
  // (e.g. gift-voucher denominations) show only that slide (no swiping between
  // them); otherwise scroll a normal gallery to the matching slide.
  function showVariantMedia(v) {
    if (!v) return;
    var tagged = document.querySelectorAll('.pdp-slider-slide.pdp-slide--variant');
    if (tagged.length) {
      for (var i = 0; i < tagged.length; i++) {
        var isActive = String(tagged[i].getAttribute('data-pdp-variant-media')) === String(v.id);
        tagged[i].classList.toggle('pdp-slide--active', isActive);
      }
      return;
    }
    if (!v.image_key) return;
    var slides = document.querySelectorAll('.pdp-slider-slide');
    for (var j = 0; j < slides.length; j++) {
      var img = slides[j].querySelector('img.pdp-image__main');
      if (img && img.getAttribute('src') && img.getAttribute('src').indexOf(v.image_key) !== -1) {
        var wrapper = slides[j].closest('.pdp-slider-wrapper');
        if (wrapper) wrapper.scrollTo({ left: slides[j].offsetLeft - wrapper.offsetLeft, behavior: 'smooth' });
        return;
      }
    }
  }
  function refreshVariant(el) {
    var form = productScope(el);
    var data = variantData();
    if (!data) return;
    applyVariant(form, matchVariant(data, currentSelection(form)));
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches &&
        e.target.matches('[data-pdp-type="VARIANT_PICKER"] input[type="radio"]')) {
      refreshVariant(e.target);
    }
  });

  // -------------------------------------------------------------- add to cart
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-pdp-action-type="add-to-cart"]');
    if (!atc) return;
    var disabled = (atc.getAttribute('data-pdp-disabled') || '').trim() === 'true';
    if (disabled) { e.preventDefault(); return; }

    var form = productScope(atc);
    var variant = atc.getAttribute('data-pdp-action-variant-id') ||
      form.getAttribute('data-pdp-form-variant-id');
    if (!variant) return; // let the <a href="/cart/…"> permalink handle it

    e.preventDefault();
    e.stopImmediatePropagation();

    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var plan = selectedPlan(form);
    var body = { id: variant, quantity: qty };
    if (plan) body.selling_plan = plan;

    atc.setAttribute('aria-busy', 'true');
    cleanFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
        return r.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (!openDrawer()) window.location.href = window.location.origin + '/cart';
      })
      .catch(function () {
        // last-resort: the permalink add (adds 1, goes to /cart)
        if (atc.getAttribute('href')) window.location.href = atc.getAttribute('href');
      })
      .then(function () { atc.removeAttribute('aria-busy'); });
  }, true);

  // -------------------------------------------------------- overlays (image/info)
  var openHosts = [];
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pdp-action-type="open-overlay"]');
    if (!trigger) return;
    // Always stop the default — these are <button>s inside the product <form>
    // with no type="button", so a plain click would submit + reload the page.
    e.preventDefault();
    e.stopPropagation();
    var id = trigger.getAttribute('data-pdp-action-id');
    if (id) {
      var panel = document.querySelector('[data-pdp-panel="' + id + '"]') || document.querySelector('.i' + id);
      if (!panel) return;
      var host = panel.closest('.pdp-dropdown--wrapper, .pdp-overlay') || panel;
      var isOpen = host.getAttribute('data-state') === 'open';
      host.setAttribute('data-state', isOpen ? 'closed' : 'open');
      if (isOpen) openHosts = openHosts.filter(function (h) { return h !== host; });
      else if (openHosts.indexOf(host) < 0) openHosts.push(host);
    } else {
      // no id → an in-panel close (X) button → close its overlay
      var ov = trigger.closest('[data-pdp-type="overlay"]');
      if (ov) {
        ov.setAttribute('data-state', 'closed');
        openHosts = openHosts.filter(function (h) { return h !== ov; });
      }
    }
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      openHosts.forEach(function (h) { h.setAttribute('data-state', 'closed'); });
      openHosts = [];
    }
  });
  // Click the dimmed backdrop (not the panel) to close the overlay/side panel.
  document.addEventListener('click', function (e) {
    var ov = e.target.closest('[data-pdp-type="overlay"]');
    if (ov && e.target === ov && ov.getAttribute('data-state') === 'open') {
      ov.setAttribute('data-state', 'closed');
      openHosts = openHosts.filter(function (h) { return h !== ov; });
    }
  });

  // ------------------------------------------------------------- carousel
  function initSliders(root) {
    (root || document).querySelectorAll('.pdp-slider').forEach(function (slider) {
      if (slider.__lvSlider) return;
      slider.__lvSlider = true;
      var wrapper = slider.querySelector('.pdp-slider-wrapper');
      if (!wrapper) return;
      wrapper.style.display = 'flex';
      wrapper.style.flexWrap = 'nowrap';
      wrapper.style.overflowX = 'auto';
      wrapper.style.scrollSnapType = 'x mandatory';
      wrapper.style.scrollBehavior = 'smooth';
      wrapper.style.webkitOverflowScrolling = 'touch';
      wrapper.querySelectorAll('.pdp-slider-slide').forEach(function (s) {
        s.style.scrollSnapAlign = 'start';
        s.style.flex = '0 0 auto';
      });
      var id = slider.getAttribute('data-pdp-slider-id');
      var next = id && document.querySelector('.pdp-slider-' + id + '-button-next');
      var prev = id && document.querySelector('.pdp-slider-' + id + '-button-prev');
      function step(dir) { wrapper.scrollBy({ left: dir * wrapper.clientWidth * 0.85, behavior: 'smooth' }); }
      if (next) next.addEventListener('click', function (ev) { ev.preventDefault(); step(1); });
      if (prev) prev.addEventListener('click', function (ev) { ev.preventDefault(); step(-1); });
    });
  }

  function init(root) { initSliders(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // ------------------------------------------------ press-and-hold image swap
  // Touch equivalent of the desktop hover-swap: holding a finger on the main
  // product image reveals the 2nd image (via .pdp-media--pressed); lifting or
  // dragging away (scroll) reverts. Only a media box with a hover overlay reacts.
  (function () {
    var pressed = null, sx = 0, sy = 0;
    function targetFor(node) {
      var el = node && node.closest ? node.closest('.pdp-media-2') : null;
      return (el && el.querySelector('.pdp-image__hover')) ? el : null;
    }
    function release() {
      if (pressed) { pressed.classList.remove('pdp-media--pressed'); pressed = null; }
    }
    document.addEventListener('touchstart', function (e) {
      var el = targetFor(e.target);
      if (!el) return;
      pressed = el;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      el.classList.add('pdp-media--pressed');
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!pressed) return;
      var t = e.touches[0];
      if (Math.abs(t.clientX - sx) > 12 || Math.abs(t.clientY - sy) > 12) release();
    }, { passive: true });
    document.addEventListener('touchend', release, { passive: true });
    document.addEventListener('touchcancel', release, { passive: true });
  })();
})();
